import { render, staticRenderFns } from "./OverRoos.vue?vue&type=template&id=101f02c2&scoped=true&"
import script from "./OverRoos.vue?vue&type=script&lang=js&"
export * from "./OverRoos.vue?vue&type=script&lang=js&"
import style0 from "./OverRoos.vue?vue&type=style&index=0&id=101f02c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101f02c2",
  null
  
)

export default component.exports